import { render, staticRenderFns } from "./OrdersReport.vue?vue&type=template&id=5cc4042b&scoped=true&"
import script from "./OrdersReport.vue?vue&type=script&lang=js&"
export * from "./OrdersReport.vue?vue&type=script&lang=js&"
import style0 from "./OrdersReport.vue?vue&type=style&index=0&id=5cc4042b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc4042b",
  null
  
)

export default component.exports